import { render } from "./menuStepTable.vue?vue&type=template&id=48efea76&ts=true"
import script from "./menuStepTable.vue?vue&type=script&lang=ts"
export * from "./menuStepTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__